app.service('cadSyncService', function ($http) {

  this.updateIssueResolved = function (obj) {
    return $http.post(`/cadSync/updateIssueResolved`, obj)
      .then(function (response) {
        return response
      })
  }

  this.loadUnsignedDocs = function (obj) {
    return $http.post(`/cadSync/loadUnsignedDocs`, obj)
      .then(function (response) {
        return response
      })
  }

  this.deleteNote = function (obj) {
    return $http.post(`/cadSync/deleteNote`, obj)
      .then(function (response) {
        return response
      })
  }

  this.loadNotes = function (obj) {
    return $http.post(`/cadSync/loadNotes`, obj)
      .then(function (response) {
        return response
      })
  }

  this.saveNote = function (obj) {
    return $http.post(`/cadSync/saveNote`, obj)
      .then(function (response) {
        return response
      })
  }

  this.updateNote = function (obj) {
    return $http.post(`/cadSync/updateNote`, obj)
      .then(function (response) {
        return response
      })
  }

  this.sendEmail = function (obj) {
    return $http.post(`/cadSync/sendEmail`, obj)
      .then(function (response) {
        return response
      })
  }

  this.saveAction = function (obj) {
    return $http.post(`/cadSync/saveAction`, obj)
      .then(function (response) {
        return response
      })
  }

  this.loadCADIssues = function (obj) {
    console.log('loadCADIssues obj :>> ', obj);
    return $http.post(`/cadSync/loadCADIssues`, obj)
      .then(function (response) {
        return response
      })
  }


  this.loadCadOptions = function (obj) {
    return $http.post(`/cadSync/loadCadOptions`, obj)
      .then(function (response) {
        return response
      })
  }

  this.updateUploadsTable = function (obj) {
    return $http.post(`/cadSync/updateUploadsTable`, obj)
      .then(function (response) {
        return response
      })
  }



})